
import React from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle, HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ConnectionErrorProps {
  error: string;
  showTroubleshooting: boolean;
  onToggleTroubleshooting: () => void;
  onTestConnection: () => void;
}

export const ConnectionError: React.FC<ConnectionErrorProps> = ({
  error,
  showTroubleshooting,
  onToggleTroubleshooting,
  onTestConnection,
}) => {
  return (
    <>
      <Alert variant="destructive" className="mb-4">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Connection Failed</AlertTitle>
        <AlertDescription>
          {error}
          <Button
            variant="link"
            className="p-0 h-auto text-sm"
            onClick={onToggleTroubleshooting}
          >
            View troubleshooting tips
          </Button>
        </AlertDescription>
      </Alert>

      {showTroubleshooting && (
        <div className="bg-slate-50 p-4 rounded-md mb-4 text-sm">
          <h4 className="font-medium mb-2 flex items-center gap-2">
            <HelpCircle className="h-4 w-4" /> Troubleshooting Tips
          </h4>
          <ul className="list-disc list-inside space-y-1 text-muted-foreground">
            <li>Verify your webhook URL is correct and starts with "https://hooks.slack.com/services/"</li>
            <li>Ensure your Bot Token starts with "xoxb-" and is properly formatted</li>
            <li>Check that you've added all the required permissions to your Slack app</li>
            <li>Try creating a new Slack app using the template provided</li>
            <li>Make sure your Slack workspace allows app installations</li>
          </ul>
          <Button 
            variant="outline" 
            size="sm" 
            className="mt-3"
            onClick={onTestConnection}
          >
            Test Connection Again
          </Button>
        </div>
      )}
    </>
  );
};
